import { createPendingLoader } from '@beatgig/ui/pending-loader'

export const AlgoliaPendingLoader = createPendingLoader()
